import React from 'react';
import PropTypes from 'prop-types';
import ContentBox from '../../layout/component/ContentBox';
import Row from '../../bootstrap/component/Row';
import Column from '../../bootstrap/component/Column';
import currentUserHasAccess from '../../../util/widget-helper';
import {LOW_NPS_REASON_WIDGET_CONTAINER} from '../../process/ui-definition/process-ui';
import Checkbox from "../../form/component/Checkbox";
import {lifecycle} from "recompose";
import moment from "moment";

const LOW_NPS_REASON_LIST = [
    { id: 'aligner_fit', value: 'Aligner fit' },
    { id: 'aligner_quality', value: 'Aligner quality' },
    { id: 'photo_check_up', value: 'Photo check up' },
    { id: 'treatment_progress_in_general', value: 'Treatment progress in general' },
    { id: 'treatment_result', value: 'Treatment result' },
    { id: 'refinement_not_granted', value: 'Refinement not granted' },
    { id: 'response_time', value: 'Response time' },
    { id: 'response_quality', value: 'Response quality' },
    { id: 'app_usability', value: 'APP Usability' },
    { id: 'general_support', value: 'General support (e.g. no physical contact)' },
    { id: 'other_medical_issues', value: 'Other medical issues' },
    { id: 'delivery_issues', value: 'Delivery issues' },
    { id: 'unknown', value: 'unknown' },
    { id: 'others', value: 'others' },
];

const LowNpsReasonWidget = ({ lowNpsReasonList, toggleLowNpsReason, saveLowNpsReason, feedbackCreated, feedbackScore }) => {
    if (!currentUserHasAccess(LOW_NPS_REASON_WIDGET_CONTAINER)) {
        return null;
    }

    if (!feedbackCreated) {
        return null;
    }

    const createdParsed = (feedbackCreated) ? moment(feedbackCreated).format('DD.MM.YYYY, HH:mm') : '';
    return (
        <ContentBox title="Low NPS reason">
            <Row top="M">
                <Column size={4}>
                    <table className="process-info-table">
                        <tbody>
                        <tr>
                            <td>Feedback created:</td>
                            <td>{createdParsed}</td>
                        </tr>
                        </tbody>
                    </table>
                </Column>
                <Column size={4}>
                    <table className="process-info-table">
                        <tbody>
                        <tr>
                            <td>Feedback score:</td>
                            <td>{feedbackScore}</td>
                        </tr>
                        </tbody>
                    </table>
                </Column>
            </Row>
            <Row top="M">
                <Column size={6}>
                    <div>
                        {
                            LOW_NPS_REASON_LIST.map(reason => {
                                const isLowNpsReason = (reason.id) ? lowNpsReasonList.includes(reason.id) : false;
                                return (
                                <Checkbox
                                    key={reason.id}
                                    object={{ lowNpsReason: isLowNpsReason }}
                                    onChange={() => {
                                        toggleLowNpsReason(reason.id, !isLowNpsReason)
                                        saveLowNpsReason()
                                    }}
                                    name="lowNpsReason">{reason.value}
                                </Checkbox>)
                            })
                        }
                    </div>
                </Column>
                <Column size={6} />
            </Row>
        </ContentBox>
    )
}

LowNpsReasonWidget.propTypes = {
    lowNpsReasonList: PropTypes.array.isRequired,
    toggleLowNpsReason: PropTypes.func.isRequired,
    saveLowNpsReason: PropTypes.func.isRequired,
    getFeedback: PropTypes.func.isRequired,
}

export default lifecycle({
    componentDidMount () {
        this.props.getFeedback()
    },
})(LowNpsReasonWidget)



// WEBPACK FOOTER //
// ./src/modules/feedback/component/LowNpsReasonWidget.js